import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import './WelcomePopup.css';

const STORAGE_KEY = 'hideWelcomeTrainingPopup';

const WelcomePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY) !== 'true') {
      setIsVisible(true);
    }
  }, []);

  const closePopup = () => {
    if (dontShowAgain) {
      localStorage.setItem(STORAGE_KEY, 'true');
    }

    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="welcome-popup-overlay" role="dialog" aria-modal="true" aria-label="Welcome popup">
      <div className="welcome-popup-modal">
        <button className="welcome-popup-close" type="button" aria-label="Close popup" onClick={closePopup}>
          <X size={24} strokeWidth={2.5} />
        </button>

        <img
          className="welcome-popup-image"
          src={`${process.env.PUBLIC_URL}/batchtranning.jpg`}
          alt="Batch training"
        />

        <label className="welcome-popup-checkbox">
          <input
            type="checkbox"
            checked={dontShowAgain}
            onChange={(event) => setDontShowAgain(event.target.checked)}
          />
          <span>Don't show again</span>
        </label>
      </div>
    </div>
  );
};

export default WelcomePopup;
